import { getRequest } from './api'

/**
 * Fetch all permissions from the database
 */
export async function listPermissions() {
  return getRequest('permissions')
}

/**
 * Fetch a single permission by ID
 */
export async function fetchPermission(id) {
  return getRequest(`permissions/${id}`)
}
